import * as React from "react";
import { singleton } from "logic/singleton";
const MetricsContext = React.createContext(void 0);
export default singleton("contexts.MetricsContext", () => MetricsContext);
